// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ee0fae15","239":"63974a7b","453":"5895d431","732":"5e98ee21"}[chunkId] + ".chunk.js";
};